import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Layout from "../../components/Layout";
import PageHero from "../../components/PageHero";
import InfoFooter from "../../components/InfoFooter";
import PhotoGrid from "../../components/PhotoGrid";
import useAlbums from "../../hooks/useAlbums";

import heroImage from "../../img/pano_56.jpeg";

const Galerie = () => {
  const { albums, loading, error } = useAlbums();

  // With a single album there is nothing to choose between, so its photos
  // are shown straight away - the flat gallery the site had before.
  const singleAlbum = albums.length === 1 ? albums[0] : null;

  return (
    <Layout>
      <Helmet
        title="Galerie | Optika Volyně"
        meta={[
          {
            name: "description",
            content:
              "Foto produktů Optiky Volyně, které nabízí a poskytuje zákazníkům",
          },
          {
            name: "keywords",
            content:
              "Optika, Optometrie, Volyně, Brýle, Produkty, Služby, Čočky, Doplňky",
          },
        ]}
      />
      <main className="products-main">
        <PageHero
          image={heroImage}
          alt="ilustrační foto - interiér optiky"
          title="Galerie"
        />

        {loading && (
          <div className="loader-container">
            <div className="loader" />
          </div>
        )}

        {error && <div className="article-error">{error}</div>}

        {!loading && !error && !albums.length && (
          <div className="article-error">Zatím zde nejsou žádné fotky.</div>
        )}

        {/* No date headings here: a shop gallery is one continuous set of
            photos, not a diary, and the original site showed a plain grid. */}
        {singleAlbum && <PhotoGrid album={singleAlbum} groupByDate={false} />}

        {!singleAlbum && albums.length > 1 && (
          <div className="album-grid">
            {albums.map((album) => {
              const cover = album.coverFiles?.[0];

              return (
                <Link
                  className="album-card"
                  key={album.id}
                  to={`/galerie/${encodeURIComponent(album.name)}`}
                  state={{ album }}
                >
                  {cover ? (
                    <img
                      src={cover.thumbnailUrl}
                      alt={album.name}
                      loading="lazy"
                    />
                  ) : (
                    <div className="album-card-placeholder">
                      <span>Bez náhledu</span>
                    </div>
                  )}
                  <h2>{album.name}</h2>
                </Link>
              );
            })}
          </div>
        )}

        <InfoFooter />
      </main>
    </Layout>
  );
};

export default Galerie;
